import { BehaviorSubject } from 'rxjs';

export const activeRoute = new BehaviorSubject('');

export const XL_SCREEN = 1800;
export const SM_SCREEN = 992;